var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"home-box"},[(_vm.topshow)?_c('top',{staticClass:"bg-white"}):_vm._e(),_c('div',{staticStyle:{"min-width":"1024px"}},[_c('router-view',{staticStyle:{"min-width":"1024px"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }